export default __webpack_public_path__ + "static/media/Naruto.c7240e37.png";